import axios from "axios";
import store from "@/store";
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { removeAPIPrefix } from "../../utils/url";

let chatServiceInstance = null
const chatServiceReverb = () => chatServiceInstance
const subdomain = window.location.host.split('.')[0]
const addressAPIWithoutPrefix = removeAPIPrefix(process?.env?.VUE_APP_ARANDU_CHAT_URL)
const baseURL = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + process?.env?.VUE_APP_ARANDU_CHAT_URL
const reverbBaseURL = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + addressAPIWithoutPrefix
const reverbSecretKey = process?.env?.VUE_APP_CHAT_API_REVERB_KEY
const shouldInitializeReverb = Boolean(!chatServiceInstance && subdomain && addressAPIWithoutPrefix && reverbSecretKey)

const ChatApiService = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-type": "application/json",
        Accept: "application/json",
    },
});

ChatApiService.interceptors.request.use(
    (config) => {
        if (config?.data instanceof FormData) {
            delete config.headers['Content-type']
            delete config.headers['Content-Type']
        }

        const token = store.getters.getToken;

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

const initializeChatServiceReverb  = (userToken) => {
    if (shouldInitializeReverb && userToken) {
        const reverbWsConnection = () => {
            if (process?.env?.VUE_APP !== 'localhost') {
              return `${subdomain}.${addressAPIWithoutPrefix}`
          }
          return 'localhost'   
          }

          try {
            chatServiceInstance = new Echo({
                    broadcaster: 'reverb',
                      key: reverbSecretKey,
                      wsHost: reverbWsConnection(),
                      wsPort: process?.env?.VUE_APP === 'localhost' ? 6004: 80,
                      wssPort: process?.env?.VUE_APP === 'localhost' ? 6004 : 443,
                      forceTLS: window.location.protocol === 'https',
                      path: process?.env?.VUE_APP === 'localhost' ? '/app' : '/chat-app',
                      enabledTransports: ['ws', 'wss'],
                      authEndpoint: `${reverbBaseURL}/broadcasting/auth`,
                      auth: {
                          headers: {
                              Authorization: 'Bearer ' + userToken,
                          },
                      }
                  })
        } catch (error) {
            console.error(error)
        }
    }
}

const leaveChatServiceReverbPrivateChannel = (channelName) => {
    if (chatServiceInstance && channelName) {
        chatServiceInstance.leave(`private-${channelName}`)
    }
}

const verifyChatServiceReverbConnection = (consumerId) => {
    if (chatServiceInstance && consumerId) {
        let connected = false
        try {
            chatServiceReverb().private(`App.Models.User.${consumerId}`)
            connected = true
        } catch (error) {
            console.erro("Chat WS: ", error)
        } finally {
            if (connected) {
                setTimeout(() => {
                    chatServiceReverb().leave(`App.Models.User.${consumerId}`)
                }, 10000)
            }
        }
    }
}

export {
    verifyChatServiceReverbConnection,
    leaveChatServiceReverbPrivateChannel,
    initializeChatServiceReverb,
    chatServiceReverb,
    ChatApiService
}